/** Persisted UI locale for the admin shell (cs | en | sk). */
export const ADMIN_LOCALE_STORAGE_KEY = 'rpapp-admin-locale';

export type AdminSupportedLocale = 'cs' | 'en' | 'sk';

export function readStoredAdminLocale(): AdminSupportedLocale | null {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(ADMIN_LOCALE_STORAGE_KEY);
    if (raw === 'cs' || raw === 'en' || raw === 'sk') {
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeStoredAdminLocale(locale: AdminSupportedLocale): void {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(ADMIN_LOCALE_STORAGE_KEY, locale);
  } catch {
    // Quota or private mode — ignore
  }
}
